// extracted by mini-css-extract-plugin
module.exports = {"status2":"staff2_status2__2MDBN","row":"staff2_row__6mOCh"};